export enum AppRoutes {
  main = '/',
  alerts = '/alerts',
  respondentInterviews = '/respondent-interviews',
  interviews = '/interviews',
  appSettings = '/app-settings',
  feedbacks = '/feedbacks',
  login = '/login',
  oneTimeLink = '/one-time-link',
  oneTimeToken = '/one-time-token',
  test = '/test',
  workspaces = '/workspaces',
  userInvite = '/user/invite',
  dashboard = '/dashboard',
  settings = '/settings',
  policy = '/privacy-policy',
  terms = '/terms-and-conditions',
  learnerOnboarding = '/get-started',

  conversationStartersManagement = '/conversation-starters-management',
  systemAdminDashboard = '/system-admin-dashboard',
  dbDocsViewer = '/system-admin-dashboard/db-docs',
  offboardingHistory = '/system-admin-dashboard/offboarding-history',
  changelogManagement = '/changelog-management',
  changelogUserReadsAudit = '/changelog-user-reads-audit',
  emailTemplates = '/email-templates',
  toolManagement = '/tool-management',
  productManagement = '/product-management',
  flows = '/flows',
  inductionCategories = '/induction-categories',
  workspaceAllSpaces = '/all-spaces',
  workspaceOffboarding = '/college-offboarding',

  cpdNotice = '/cpd-notice',
  whatsNew = '/whats-new',
  artifact = '/artifact'
}
